import { render, staticRenderFns } from "./SyspaEditDialog.vue?vue&type=template&id=32340186&scoped=true&"
import script from "./SyspaEditDialog.vue?vue&type=script&lang=js&"
export * from "./SyspaEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32340186",
  null
  
)

export default component.exports